import { render, staticRenderFns } from "./CourseDeals.vue?vue&type=template&id=c43df2d0&scoped=true"
import script from "./CourseDeals.vue?vue&type=script&lang=js"
export * from "./CourseDeals.vue?vue&type=script&lang=js"
import style0 from "./CourseDeals.vue?vue&type=style&index=0&id=c43df2d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43df2d0",
  null
  
)

export default component.exports